<template>
  <div id="service-area" class="bg-[#F3F7FA]">
    <div class="container mx-auto px-3 lg:py-16 py-10 ">
      <div class="lg:text-5xl text-4xl text-2xl font-primary text-center font-bold lg:mb-10 mb-2">Service Area</div>
      <div class="flex items-center flex-col-reverse lg:flex-row gap-2 bg-white ">
        <div class="lg:w-[40%] w-full hover:cursor-pointer flex flex-col gap-3 p-4">
          <div class="w-full group rounded-lg  overflow-hidden shadow-md p-1 flex items-center maps-details "
            v-for="item, index in locations" :key="index"
            :class="[index === count ? 'bg-primary text-white hover:bg-primary' : 'hover:bg-blue-200']"
            @mouseover="change_map(index, false)" @click="change_map(index, true)" @mouseleave="change_map(count, false)">
            <div class="w-full border-x-4" :class="[index % 2 === 0 ? 'border-primary' : 'border-secondary']">
              <div class="flex items-center">
                <img src="../../assets/v-1.1/location-pin.svg" class="scale-90" alt="Marker" width="" height="" />
                <span class="lg:text-xl text-base  font-semibold font-primary ml-3">{{ item.name }}</span>
              </div>
              <div class="grid grid-cols-3 md:grid-cols-3  gap-x-2 justify-between items-center my-1">
                <div class="flex items-center" v-for="city, key in item.related_location" :key="key">
                  <span v-html="location_dot"> </span>
                  <span class="text-xs ml-2">{{
                    city
                  }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="lg:w-[66%] w-full h-full p-2">
          <iframe class="rounded w-full lg:h-[516px] h-[400px] sm:h-[400px] p-0" :title="title" :src="map_src"
            style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade" />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
const title = ref("Peel Region");
const count = ref(0);
const map_src = ref(`
https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d369195.00620376546!2d-79.99105337629081!3d43.703566254237415!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x882b3c30c9eb87ab%3A0x3bec33bf3e68e6a3!2sRegional%20Municipality%20of%20Peel%2C%20ON%2C%20Canada!5e0!3m2!1sen!2sin!4v1687844367891!5m2!1sen!2sin`);
const location_dot = `<svg width="26" height="26" viewBox="0 0 26 26" fill="#6393F2" xmlns="http://www.w3.org/2000/svg">
<circle opacity="0.3" cx="13" cy="12" r="12" fill="white"/>
<g filter="url(#filter0_d_247_2393)">
<circle cx="13" cy="12" r="5" fill="white"/>
<circle cx="13" cy="12" r="6" stroke="white" stroke-width="2"/>
</g>
<defs>
<filter id="filter0_d_247_2393" x="0" y="0" width="26" height="26" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dy="1"/>
<feGaussianBlur stdDeviation="3"/>
<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_247_2393"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_247_2393" result="shape"/>
</filter>
</defs>
</svg>`;

const locations = [
  {
    name: "Peel Region",
    related_location: ["Brampton", "Mississauga", "Caledon"],
  },
  {
    name: "York Region",
    related_location: ["Vaughan", "Markham", "King"],
  },
  {
    name: "Toronto Region",
    related_location: ["North York", "Scarborough", "Etobicoke"],
  },
  {
    name: "Halton Region",
    related_location: ["Georgetown", "Milton", "Oakville"],
  },
  {
    name: "Hamilton Region",
    related_location: [ "Hamilton", "Stoney Creek","Burlington"],
  },
  {
    name: "Waterloo Region",
    related_location: ["Cambridge", "Kitchener", "Waterloo"],
  },
];

const maps = [
  {
    title: "Peel Region",
    name: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d369195.00620376546!2d-79.99105337629081!3d43.703566254237415!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x882b3c30c9eb87ab%3A0x3bec33bf3e68e6a3!2sRegional%20Municipality%20of%20Peel%2C%20ON%2C%20Canada!5e0!3m2!1sen!2sin!4v1687844367891!5m2!1sen!2sin",
  },
  {
    title: "York Region",
    name: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d733603.7826693505!2d-80.1252346975875!3d44.090789269754644!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x882acdaee4d2a679%3A0x108dcfb46a288a64!2sRegional%20Municipality%20of%20York%2C%20ON%2C%20Canada!5e0!3m2!1sen!2sin!4v1687844461162!5m2!1sen!2sin",
  },
  {
    title: "Toronto Region",
    name: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d184551.90977186715!2d-79.54286895895231!3d43.71837095832512!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89d4cb90d7c63ba5%3A0x323555502ab4c477!2sToronto%2C%20ON%2C%20Canada!5e0!3m2!1sen!2sin!4v1687844024726!5m2!1sen!2sin",
  },
  {
    title: "Halton Region",
    name: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d370383.76632286207!2d-80.12872618357486!3d43.510196008170446!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x882b68e39c90c9cf%3A0x709a8583b0a9b219!2sRegional%20Municipality%20of%20Halton%2C%20ON%2C%20Canada!5e0!3m2!1sen!2sin!4v1687844954898!5m2!1sen!2sin",
  },
  {
    title: "Hamilton Region",
    name: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d371910.5027855414!2d-80.2634734187923!3d43.26083529159768!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x882c986c27de778f%3A0x2b6aee56d8df0e21!2sHamilton%2C%20ON%2C%20Canada!5e0!3m2!1sen!2sin!4v1710133146833!5m2!1sen!2sin",
  },
  {
    title: "Waterloo Region",
    name: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d370579.76033861155!2d-80.52831995!3d43.478248549999996!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x882c74d2afbe55cd%3A0x83aa47d6cdef0f3b!2sWaterloo%20Regional%20Municipality%2C%20ON%2C%20Canada!5e0!3m2!1sen!2sin!4v1710133014409!5m2!1sen!2sin",
  },
];
const change_map = (index, flag) => {
  if (flag) {
    count.value = index;
  }
  const mapData = maps[index];
  title.value = mapData.title;
  map_src.value = mapData.name;

};

</script>


<style scoped>
.maps-details:nth-child(odd) {
  border-right: 4px solid #005CFF;
  border-left: 4px solid #005CFF;
}

.maps-details:nth-child(even) {
  border-right: 4px solid #F2B611;
  border-left: 4px solid #F2B611;
}
</style>
